















import store from '../store';

export default {
  name: 'QrCode',
  methods: {
    showPage: (name: string) => store.showPage(name),
  },
};
